<template>
  <div>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleback('controlCenter')"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Google Analytics
          </h2>
        </div>
      </div>
    </div>
    <div
      class="bg-white fixed-top menucontrol-scroll flex justify-center items-center"
    >
      <div class="text-center w-2/5 mx-auto">
        <div class="flex items-center relative">
          <el-Input
            placeholder="Enter Tracking ID"
            v-model="googleInput"
            maxlength="20"
            :disabled="disableEdit"
            class="el-tlr"
            type="text"
          ></el-Input>

          <div class="bg-primary editbtn flex">
            <feather-icon
              icon="EditIcon"
              class="text-white flex"
              svgClasses="w-5 h-5"
            />
          </div>

          <!-- <vs-button
            type="success"
            @click="disableEdit = false"
            class="bg-success mt-6 border-0 w-1/4 font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
          >
            Edit
          </vs-button> -->
        </div>

        <p class="col-4f text-sm mt-4 font-semibold">
          You can
          <span class="text-primary cursor-pointer">Click here</span> for step
          by step procedure for tracking ID on Google Analytics.
        </p>

        <vs-button
          type="success"
          @click="createGtag"
          class="bg-success rounded-full mt-6 border-0 font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
        >
          Save
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import FeatherIcon from "../../../../../../components/FeatherIcon.vue";

export default {
  components: { FeatherIcon },
  data() {
    return {
      googleInput: null,
      disableEdit: true,
    };
  },
  methods: {
    handleback(name) {
      this.$router.push({ name: name });
    },

    async createGtag() {
      const payload = {
        projectId: this.selectedProject._id,
        gTag: this.googleInput,
      };
      await this.$store.dispatch("user/updateProject", payload);
      await this.$store.dispatch("user/getProject", payload);
      this.$swal({
        title: "Success!",
        text: `Your Tracking ID has been successfully submitted. Will notify you once the setup is completed`,
        icon: "success",

        buttons: false,
      });
      this.disableEdit = true;
    },
  },

  computed: {
    ...mapState("user", ["selectedProject"]),
  },

  mounted() {
    this.googleInput = this.selectedProject.gTag;
  },
};
</script>
